// 全局方法注入
import util from "./util";

export default {
    $wrapLink(link) {
        return util.wrapLink(link);
    },
    $redirect(link) {
        window.location.href = link;
    },
    $getScale() {
        return util.getScale();
    },
    $isMobile() {
        return util.isMobile();
    },
    $isRole(roles) {
        return util.isRole(roles);
    },
    $hasPower(power) {
        return util.hasPower(power);
    },
};
